import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { CartContext } from "@context/CardContext";
import axios from "@fetch/axios";
import { TokenContext } from "@context/TokenContext";
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";
import PaymentLoader from "@components/PaymentLoader";
import PagoExitoso from "@components/PagoExitoso";
import PagoErroneo from "@components/PagoErroneo";

const Component = () => {

  const { getToken, getVerified } = useContext(TokenContext);
  const { resetCart } = useContext(CartContext);
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user_arteonu'))
  const { lang } = useContext(LanguageCurrencyContext);
  const [loading, setLoading] = useState(true)
  const [success, setSuccess] = useState(true)

  useEffect(() => {

    //SI ES STRIPE
    const paymentIntent = new URLSearchParams(location.search).get('payment_intent');

    const fetchStripe = async (payId) => {

      setLoading(false)
      try {

        if (localStorage.getItem('cartId')) {
          const res = await axios.post(`/cart/stripe/intent?lang=${lang}&verified=` + (getVerified() ? 1 : 0),
            {
              "cart_id": localStorage.getItem('cartId'),
              "payment_intent": payId
            },
            {
              headers: { 'Authorization': 'Bearer ' + getToken() }
            }

          );
          setLoading(true)

          if (res.data) {
            if (res.data.status == 'succeeded') {
              localStorage.removeItem('compra_arteonu');
              const url = new URL(window.location.href);
              url.searchParams.delete('payment_intent');
              window.location.replace(url.pathname + (url.searchParams.toString() ? `?${url.searchParams.toString()}` : ''));

            }
            localStorage.removeItem('cartId')
            localStorage.removeItem('cart')
            localStorage.removeItem('stripe_arteonu')

            resetCart();

          }

        }
      } catch (error) {
        localStorage.removeItem('cartId')
        localStorage.removeItem('cart')
        localStorage.removeItem('stripe_arteonu')

        setSuccess(false)
        setLoading(true)
      }
    };

    if (paymentIntent) {

      localStorage.setItem('compra_arteonu', paymentIntent)

      fetchStripe(paymentIntent)

    }

    if (localStorage.getItem('stripe_arteonu') !== null) {
      fetchStripe(localStorage.getItem('stripe_arteonu'));
    }

    //SI ES PAYPAL
    const orderId = new URLSearchParams(location.search).get('token');

    const fetchPaypal = async (order_id) => {

      setLoading(false)
      try {

        if (localStorage.getItem('cartId')) {

          const res = await axios.post(`/cart/paypal/capture-order?lang=${lang}&verified=` + (getVerified() ? 1 : 0),
            {
              "cart_id": localStorage.getItem('cartId'),
              "order_id": order_id
            },
            {
              headers: { 'Authorization': 'Bearer ' + getToken() }
            }

          );

          setLoading(true)

          if (res.data) {

            localStorage.setItem('cartId', '')
            localStorage.removeItem('paypal_arteonu')
            localStorage.removeItem('compra_arteonu');
            const url = new URL(window.location.href);
            url.searchParams.delete('token');
            window.location.replace(url.pathname + (url.searchParams.toString() ? `?${url.searchParams.toString()}` : ''));


            resetCart();

          }

        }
      } catch (error) {
        localStorage.removeItem('cartId')
        localStorage.removeItem('cart')
        localStorage.removeItem('stripe_arteonu')
        setSuccess(false)
        setLoading(true)
      }
    };

    if (orderId) {

      localStorage.setItem('paypal_arteonu', orderId)

      fetchPaypal(orderId)

    }

    if (localStorage.getItem('paypal_arteonu') !== null) {
      fetchPaypal(localStorage.getItem('paypal_arteonu'));
    }


  }, [])

  return (
    <section className="CheckoutBox CompraExitosa">
      {!loading ? (
        <PaymentLoader />
      ) : success ? (
        <PagoExitoso user={user} />
      ) : (
        <PagoErroneo user={user} />
      )}
    </section>
  );
};

export default Component;
